import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const DonationCategories = lazy(() => import('../../../container/organizations-listings/donation-categories'));
const DonationListings = lazy(() => import('../../../container/organizations-listings/donations'));
const View = lazy(() => import('../../../container/organizations-listings/donations/View'));
const Add = lazy(() => import('../../../container/organizations-listings/donations/Add'));
const Edit = lazy(() => import('../../../container/organizations-listings/donations/Edit'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/donation-categories`} component={DonationCategories} />
      <Route exact path={`${path}/donation-listings`} component={DonationListings} />
      <Route exact path={`${path}/donation-listings/add`} component={Add} />
      <Route exact path={`${path}/donation-listings/view/:slug`} component={View} />
      <Route exact path={`${path}/donation-listings/edit/:slug`} component={Edit} />
    </Switch>
  );
}

export default PagesRoute;
